exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".filter-label {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.help-text {\n  color: #666;\n  margin-bottom: 8px;\n}\n\n.full-width-multiselect {\n  display: block;\n  width: 100%;\n}\n\n.light-grey-bg {\n  background: #f5f5f5;\n}\n\n.error-card {\n  background: #fdecea;\n}\n\n.ml-base {\n  margin-left: 12px;\n}\n\n.mt-base {\n  margin-top: 12px;\n}\n\n.mt-base-double {\n  margin-top: 24px;\n}\n\n@-webkit-keyframes spin {\n  from { -webkit-transform: rotate(0deg); transform: rotate(0deg); }\n  to { -webkit-transform: rotate(360deg); transform: rotate(360deg); }\n}\n\n@keyframes spin {\n  from { -webkit-transform: rotate(0deg); transform: rotate(0deg); }\n  to { -webkit-transform: rotate(360deg); transform: rotate(360deg); }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/transaction-profile-export/transaction-profile-export.component.css
// module id = 1938
// module chunks = 0